import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Interceptors
import { SessionInterceptor } from './contabilidad/interceptors/session.interceptor';
import { SidebarModule } from './sidebar/sidebar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { ContabilidadModule} from './contabilidad/contabilidad.module';
import { PagesnavbarModule} from './shared/pagesnavbar/pagesnavbar.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppRoutes } from './app.routing';
import {  } from '@angular/http';
import { Location, LocationStrategy, HashLocationStrategy} from '@angular/common';

import { ScrollingModule } from '@angular/cdk/scrolling';
@NgModule({
    imports:      [
        BrowserAnimationsModule,ScrollingModule,
        FormsModule,
        RouterModule.forRoot(AppRoutes,
    { useHash: true }),
        HttpModule,
        SidebarModule,
        HttpClientModule,
        NavbarModule,
        FooterModule,
        ContabilidadModule,
        FixedPluginModule,
        PagesnavbarModule
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent
    ], providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true
    }
  ],
    bootstrap:    [ AppComponent]
})

export class AppModule { }
